/**
 * Форматирование строки
 */
export function formatString(str: string, ...args: any[]): string {
  return str.replace(/{(\d+)}/g, function (match, number) {
    return typeof args[number] !== 'undefined' ? args[number] : match;
  });
}
